function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,172v-172h172v172z",
  fill: "none"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#ffffff"
}, React.createElement("g", {
  id: "surface1"
}, React.createElement("path", {
  d: "M150.5,44.53972c-4.74512,2.09961 -9.84017,3.49935 -15.21517,4.15723c5.45899,-3.2474 9.6722,-8.42643 11.64583,-14.5433c-5.12305,3.00944 -10.79199,5.20703 -16.81087,6.36882c-4.8151,-5.10905 -11.68783,-8.27246 -19.30241,-8.27246c-14.61328,0 -26.46907,11.74382 -26.46907,26.23112c0,2.04362 0.23795,4.04525 0.68587,5.97689c-21.98991,-1.0918 -41.50228,-11.54785 -54.54785,-27.4209c-2.29557,3.87728 -3.58333,8.41243 -3.58333,13.21354c0,9.09831 4.66113,17.11881 11.77181,21.83594c-4.33919,-0.12598 -8.42643,-1.34375 -11.99577,-3.27539c0,0.08399 0,0.19597 0,0.30794c0,12.72363 9.1263,23.31966 21.22005,25.74121c-2.21159,0.60189 -4.54916,0.93783 -6.95671,0.93783c-1.70768,0 -3.37337,-0.19596 -4.98307,-0.48991c3.35938,10.40007 13.12956,18.00065 24.7194,18.22461c-9.07031,7.02669 -20.47819,11.23991 -32.87988,11.23991c-2.1416,0 -4.24121,-0.12598 -6.31283,-0.37793c11.72982,7.41862 25.64323,11.77181 40.57845,11.77181c48.68294,0 75.31999,-39.97656 75.31999,-74.66211c0,-1.13379 -0.04199,-2.26758 -0.09798,-3.37338c5.19303,-3.68131 9.6722,-8.30045 13.21354,-13.59147"
})));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    width: "48px",
    height: "48px",
    ref: svgRef
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _ref2, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.159bb105.svg";
export { ForwardRef as ReactComponent };